import { Tour } from 'nextstepjs';

export const steps: Tour[] = [
  {
    tour: 'mainTour',
    steps: [
      {
        icon: '👋',
        title: 'Seja bem-vindo(a) ao Zeki',
        content: (
          <>
            Neste tutorial guiado, você vai conhecer os principais módulos e aprender os primeiros
            passos para usar a plataforma.
            <br />
            <br />
            Use os botões abaixo para navegar e avançar no seu ritmo.
          </>
        ),
        showControls: true,
        showSkip: true,
      },
      {
        icon: '🚀',
        title: 'Automação para o Pós-Venda',
        content:
          'O Zeki exibe os principais indicadores do seu negócio. Integrado com seu e-commerce, ERP e canais de comunicação WhatsApp/SMS/E-mail.',
        selector: '#dashboard',
        nextRoute: '/dashboard/config?tab=integrations',
        side: 'bottom',
        pointerPadding: 10,
        pointerRadius: 5,
        showControls: true,
        showSkip: true,
      },
      {
        icon: '🎛️',
        title: 'Configure suas Integrações',
        content: 'Integre com seu e-commerce, ERP e canais de comunicação favoritos.',
        selector: '#integrations-tab',
        nextRoute: '/dashboard/purchase',
        prevRoute: '/dashboard',
        side: 'right',
        pointerPadding: 10,
        pointerRadius: 5,
        showControls: true,
        showSkip: true,
      },
      {
        icon: '🛍️',
        title: 'Importando suas Vendas',
        content:
          'Todo o seu histórico de vendas será importado e a partir de agora estará sincronizado em tempo real com o Zeki.',
        selector: '#sales-list',
        side: 'left-top',
        nextRoute: '/dashboard/customer',
        prevRoute: '/dashboard/config?tab=integrations',
        pointerPadding: 10,
        pointerRadius: 5,
        showControls: true,
        showSkip: true,
      },
      {
        icon: '🙋',
        title: 'Importando seus Clientes',
        content:
          'Todos os seus Clientes também serão importados e a partir de agora também serão sincronizados em tempo real com o Zeki.',
        selector: '#customers-list',
        side: 'left-top',
        nextRoute: '/dashboard/product',
        prevRoute: '/dashboard/purchase',
        pointerPadding: 10,
        pointerRadius: 5,
        showControls: true,
        showSkip: true,
      },
      {
        icon: '👝',
        title: 'Importando seus Produtos',
        content:
          'Todos os seus Produtos serão importados e sincronizados em tempo real com o Zeki.',
        selector: '#products-list',
        side: 'left-top',
        nextRoute: '/dashboard',
        prevRoute: '/dashboard/customer',
        pointerPadding: 10,
        pointerRadius: 5,
        showControls: true,
        showSkip: true,
      },
      {
        icon: '📊',
        title: 'Inteligência de Negócio',
        content:
          'Os dados importados de Vendas, Clientes, Produtos e Giftbacks serão exibidos nos seus respectivos Dashboards, para basearem tomadas de decisão assertivas.',
        selector: '#dashboard-analytics-customer',
        side: 'right',
        prevRoute: '/dashboard/product',
        pointerPadding: 10,
        pointerRadius: 5,
        showControls: true,
        showSkip: true,
      },
      {
        icon: '🤑',
        title: 'Fidelize clientes e aumente o LTV!',
        content:
          'Defina os parâmetros da matriz RFM e da estratégia de Giftbacks com base nos dados!\nAgende uma reunião com nossa equipe e vamos vender mais:',
        selector: '#rfm-analytics',
        side: 'left',
        prevRoute: '/dashboard',
        pointerPadding: 10,
        pointerRadius: 5,
        showControls: true,
        showSkip: true,
      },
      {
        icon: '🎉🎉🎉',
        title: 'Por hoje é só!',
        content:
          'Não deixei de visitar nossa Central de Ajuda para tutoriais detalhados sobre cada funcionalidade do Zeki.',
        pointerPadding: 10,
        pointerRadius: 5,
        showControls: true,
        showSkip: true,
      },
    ],
  },
  {
    tour: 'agendaTour',
    steps: [
      {
        icon: '⚙️',
        title: 'Configure sua Agenda',
        content:
          'Defina horários, regras de antecedência, profissionais e a página pública da sua unidade.',
        selector: '#agenda-settings-btn',
        side: 'bottom',
        pointerPadding: 8,
        pointerRadius: 8,
        showControls: true,
        showSkip: true,
      },
      {
        icon: '✂️',
        title: 'Organize seu catálogo',
        content:
          'Cadastre serviços, valores e durações. Essas informações determinam os horários que o cliente poderá escolher.',
        selector: '#agenda-services-shortcut',
        side: 'bottom',
        pointerPadding: 8,
        pointerRadius: 8,
        showControls: true,
        showSkip: true,
      },
      {
        icon: '📅',
        title: 'Agende pela recepção',
        content:
          'Use este botão para criar um agendamento interno e escolher cliente, serviço, profissional e horário.',
        selector: '#agenda-new-appointment-btn',
        side: 'bottom',
        pointerPadding: 8,
        pointerRadius: 8,
        showControls: true,
        showSkip: true,
      },
      {
        icon: '🔗',
        title: 'Compartilhe seu link público',
        content:
          'Copie o link da sua página e divulgue no WhatsApp e Instagram para receber agendamentos 24 horas por dia.',
        selector: '#agenda-public-link-card',
        side: 'bottom',
        pointerPadding: 10,
        pointerRadius: 10,
        showControls: true,
        showSkip: true,
      },
    ],
  },
  {
    tour: 'loyaltyTour',
    steps: [
      {
        icon: '⚙️',
        title: 'Dê identidade ao programa',
        content:
          'Defina nome, validade e cor. Quando a estrutura estiver pronta, ative o programa e salve para publicar a experiência aos clientes.',
        selector: '#loyalty-program-card',
        side: 'left',
        pointerPadding: 10,
        pointerRadius: 10,
        showControls: true,
        showSkip: true,
      },
      {
        icon: '🔗',
        title: 'Divulgue sua página pública',
        content:
          'Copie o link exclusivo da loja e compartilhe no WhatsApp, Instagram ou onde seus clientes já conversam com você.',
        selector: '#loyalty-public-page-card',
        side: 'left',
        pointerPadding: 10,
        pointerRadius: 10,
        showControls: true,
        showSkip: true,
      },
      {
        icon: '⚡',
        title: 'Defina como acumular pontos',
        content:
          'Crie regras para compras, cadastro, aniversário ou ações manuais. Uma regra simples por valor gasto é um bom ponto de partida.',
        selector: '#loyalty-rules-tab',
        side: 'bottom',
        pointerPadding: 8,
        pointerRadius: 8,
        showControls: true,
        showSkip: true,
      },
      {
        icon: '🏅',
        title: 'Reconheça quem mais se relaciona',
        content:
          'Organize níveis como Bronze, Prata e Ouro para tornar a evolução visível e liberar benefícios permanentes.',
        selector: '#loyalty-tiers-tab',
        side: 'bottom',
        pointerPadding: 8,
        pointerRadius: 8,
        showControls: true,
        showSkip: true,
      },
      {
        icon: '🎁',
        title: 'Transforme pontos em desejo',
        content:
          'Cadastre descontos, brindes, produtos ou benefícios e escolha se cada recompensa estará disponível no PDV, na página pública ou nos dois.',
        selector: '#loyalty-rewards-tab',
        side: 'bottom',
        pointerPadding: 8,
        pointerRadius: 8,
        showControls: true,
        showSkip: true,
      },
      {
        icon: '🎟️',
        title: 'Acompanhe cada resgate',
        content:
          'Consulte códigos, clientes, recompensas e status. Os resgates iniciados na página pública ou atendidos no PDV aparecem aqui.',
        selector: '#loyalty-redemptions-tab',
        side: 'bottom-right',
        pointerPadding: 8,
        pointerRadius: 8,
        showControls: true,
        showSkip: true,
      },
    ],
  },
];
